export default function SectionTitle({
  badge,
  title,
  description,
  align = "center",
}) {
  const alignment = {
    left: "text-left",
    center: "text-center",
  }

  return (
    <div
      className={`
        max-w-3xl
        ${align === "center" ? "mx-auto" : ""}
        ${alignment[align]}
      `}
    >
      {badge && (
        <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
          {badge}
        </span>
      )}

      <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
        {title}
      </h2>

      {description && (
        <p className="mt-5 text-gray-600 leading-relaxed text-lg">
          {description}
        </p>
      )}
    </div>
  )
}